/* ÜBERGANG — welches Bild von einer Seite zur naechsten wandert.
 *
 * Die Blende zwischen zwei Seiten macht der Browser allein (siehe
 * hoa-uebergang.css). Was er NICHT allein weiss: dass das kleine Shirt
 * in der Kollektion und das grosse Shirt auf der Produktseite dasselbe
 * Shirt sind. Das sind rund 40 Zeilen.
 *
 * Der Ablauf:
 *   1. Jemand tippt in der Kollektion auf eine Kachel.
 *      -> Dieses eine Bild bekommt `hoa-held`. SOFORT, im selben
 *         Klick — danach ist es zu spaet, der Browser hat das Bild
 *         dann schon festgehalten.
 *   2. Die Produktseite laedt.
 *      -> Das grosse Bild bekommt denselben Namen.
 *   3. Der Browser sieht zweimal `hoa-held` und rechnet den Weg.
 *
 * Die Falle, die das hier teuer gemacht haette: Ein Name darf auf einer
 * Seite nur EINMAL vergeben sein. Kommt jemand mit „zurueck“ auf die
 * Kollektion und das alte Bild traegt den Namen noch, waehrend ein
 * zweites dazukommt, bricht der ganze Uebergang ab — und zwar still.
 * Deshalb wird vor jeder Vergabe aufgeraeumt.
 */
(function () {
  "use strict";

  /* Kann der Browser ueberhaupt Uebergaenge zwischen Seiten? Firefox
     heute nicht. Dann macht dieses Skript gar nichts, und der Laden
     verhaelt sich wie immer. */
  if (!("onpagereveal" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var NAME = "hoa-held";

  function abraeumen() {
    var alt = document.querySelectorAll("." + NAME);
    for (var i = 0; i < alt.length; i++) alt[i].classList.remove(NAME);
  }

  function taufen(el) {
    if (!el) return;
    abraeumen();
    el.classList.add(NAME);
  }

  /* ---------------------------------------------------- Hingehen
   *
   * `pointerdown` statt `click`: der Finger ist beim Antippen schon
   * unten, bevor der Klick ausgeloest wird. So ist der Name sicher
   * gesetzt, wenn die Navigation losgeht.
   */
  document.addEventListener("pointerdown", function (e) {
    var ziel = e.target.closest && e.target.closest("a[href]");
    if (!ziel) return;
    /* Nur Produktlinks. Ein Uebergang vom Warenkorbknopf zum Produkt
       waere Unsinn — da wandert nichts. */
    if (ziel.getAttribute("href").indexOf("/products/") === -1) return;

    var karte = ziel.closest(".card-wrapper, .card, .hoa-weg__kachel") || ziel;
    var bild = karte.querySelector("img") || ziel.querySelector("img");
    taufen(bild);
  }, { capture: true, passive: true });

  /* ---------------------------------------------------- Ankommen
   *
   * Der Name wird IMMER gesetzt, wenn eine Produktseite aufgeht — nicht
   * nur waehrend eines Uebergangs. Die erste Fassung stieg bei
   * `if (!e.viewTransition) return;` aus, und das Bild bekam den Namen
   * nie: der Browser fragt die Namen ab, waehrend er die Seite
   * aufdeckt, nicht danach. Ein Name auf einer Seite ohne Uebergang tut
   * nichts und kostet nichts — die Absicherung ist es wert.
   */
  function produktbildTaufen() {
    abraeumen();
    /* Dawn nennt es `.product__media img`. `.product img` waere falsch:
       das trifft auch die kleinen Vorschaubilder unter der Galerie, und
       dann fliegt das Shirt in eine Briefmarke. */
    var gross = document.querySelector(
      ".product__media-wrapper .product__media img, .product__media img");
    if (gross) taufen(gross);
  }

  window.addEventListener("pagereveal", produktbildTaufen);
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", produktbildTaufen);
  else produktbildTaufen();

  /* NICHT bei `pageswap` aufraeumen — das war der erste Entwurf und
     haette den ganzen Effekt still abgeschaltet: `pageswap` feuert,
     BEVOR der Browser das alte Bild festhaelt. Wer den Namen dort
     entfernt, nimmt ihm genau das Element weg, das wandern soll.
     Aufgeraeumt wird beim Ankommen und vor jeder neuen Vergabe.
     Bleibt der Fall „zurueck aus dem Zwischenspeicher“: dann steht die
     alte Seite mitsamt Namen wieder da. */
  window.addEventListener("pageshow", function (e) { if (e.persisted) abraeumen(); });
})();
